import {Box, CircularProgress, Typography} from "@mui/material";

interface LoadingScreenProps {
    /** Loading message to display (default: "Lädt...") */
    readonly message?: string
}

/**
 * Full-screen centered loading indicator with message
 */
export default function LoadingScreen(props: LoadingScreenProps) {
    const { message = "Lädt..." } = props

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CircularProgress />
            <Typography variant="h6" sx={{ margin: '1rem' }}>
                {message}
            </Typography>
        </Box>
    )
}
